import React from "react";
import DOMPurify from "isomorphic-dompurify";


function HtmlTextArea(props){
  
    const theObj = {__html:props.data};
    return (
        <div className="row" dangerouslySetInnerHTML={theObj} />
    )
}

export default HtmlTextArea;